import { render, staticRenderFns } from "./IconBar.vue?vue&type=template&id=198dd01f&"
import script from "./IconBar.vue?vue&type=script&lang=js&"
export * from "./IconBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports